import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Logon from '../components/Logon'
import * as logonAction from '../state/action'
import * as appAction from '../../App/state/action'
import * as getMessage from '../../../shared/containers/IntlProvider/state/actions';
import * as utils from '../../../utils';
//import * as businessInformationAction from '../../BusinessInformation/state/action';

import BasePage from '../../../shared/BasePage';
import {setTitle} from "../../../utils";

class LogonContainer extends BasePage {

    componentDidMount() {
        this.loadContentMessage()
        utils.clearUserDatas()
    }

    loadContentMessage = () => {
        this.props.getMessage('logon', 'logon_i18n');
    }

    render() {
        const { logon_i18n, homePageTitle } = this.props;

        if (logon_i18n && homePageTitle) {
          setTitle(homePageTitle + logon_i18n.logonTitle);
        }

        return logon_i18n ? <Logon { ...this.props } /> : null;
    }
}

const mapStateToProps = (state) => {
    const errMsgMapping = state.app.i18n.errorMessage;
    return {
        selectedLanguage: state.app.selectedLanguage,
        logon_i18n: state.intl.messages.logon_i18n,
        isDisplayInputErr: state.app.isDisplayInputErr,
        inputErrMsg: state.app.inputErrCode ? errMsgMapping[state.app.inputErrCode] : null,
        errLocation: state.app.errLocation,
        homePageTitle: state.app.i18n.homePageTitle
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(logonAction, dispatch),
        ...bindActionCreators(appAction, dispatch),
        ...bindActionCreators(getMessage, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogonContainer)


// WEBPACK FOOTER //
// ./src/views/Logon/container/Logon.js